"use strict";
/**
 * Shipping event types and delivery codes for credit card shipping events
 * These codes represent various delivery statuses that can occur during shipping
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingStatus = exports.InvalidTerminalDeliveryStatus = exports.ValidTerminalDeliveryStatus = void 0;
var ValidTerminalDeliveryStatus;
(function (ValidTerminalDeliveryStatus) {
    ValidTerminalDeliveryStatus["MAILBOX"] = "Delivered, In/At Mailbox";
    ValidTerminalDeliveryStatus["FRONT_PORCH"] = "Delivered, Front Door/Porch";
    ValidTerminalDeliveryStatus["GENERIC"] = "Delivered";
    ValidTerminalDeliveryStatus["LOCKER"] = "Delivered, Parcel Locker";
    ValidTerminalDeliveryStatus["LEFT_WITH_INDIVIDUAL"] = "Delivered, Left with Individual";
    ValidTerminalDeliveryStatus["PO_BOX"] = "Delivered, PO Box";
    ValidTerminalDeliveryStatus["GARAGE"] = "Delivered, Garage / Other Door / Other Location at Address";
    ValidTerminalDeliveryStatus["FRONT_DESK"] = "Delivered, Front Desk/Reception/Mail Room";
    ValidTerminalDeliveryStatus["PICKED_UP_AT_POST_OFFICE"] = "Delivered, Individual Picked Up at Post Office";
    ValidTerminalDeliveryStatus["PICKED_UP_AT_POSTAL_FACILITY"] = "Delivered, Individual Picked Up at Postal Facility";
    ValidTerminalDeliveryStatus["NEIGHBOR_AS_REQUESTED"] = "Delivered, Neighbor as Requested";
})(ValidTerminalDeliveryStatus || (exports.ValidTerminalDeliveryStatus = ValidTerminalDeliveryStatus = {}));
var InvalidTerminalDeliveryStatus;
(function (InvalidTerminalDeliveryStatus) {
    InvalidTerminalDeliveryStatus["TO_ORIGINAL_SENDER"] = "Delivered, To Original Sender";
    InvalidTerminalDeliveryStatus["ARRIVED_AT_POST_OFFICE"] = "Arrived at Post Office";
    InvalidTerminalDeliveryStatus["AWAITING_DELIVERY"] = "Awaiting Delivery";
    InvalidTerminalDeliveryStatus["HELD_AT_POST_OFFICE"] = "Held at Post Office, At Customer Request";
    InvalidTerminalDeliveryStatus["OUT_FOR_DELIVERY"] = "Out for Delivery";
    InvalidTerminalDeliveryStatus["RETURNING_PACKAGE_TO_SHIPPER"] = "Returning package to shipper";
    InvalidTerminalDeliveryStatus["NO_ACCESS_TO_DELIVERY_LOCATION"] = "No Access to Delivery Location";
    InvalidTerminalDeliveryStatus["USPS_PICKED_UP_ITEM"] = "USPS picked up item";
    InvalidTerminalDeliveryStatus["AVAILABLE_FOR_PICKUP"] = "Available for Pickup";
})(InvalidTerminalDeliveryStatus || (exports.InvalidTerminalDeliveryStatus = InvalidTerminalDeliveryStatus = {}));
var ShippingStatus;
(function (ShippingStatus) {
    ShippingStatus["IN_TRANSIT"] = "In Transit";
    ShippingStatus["DELIVERED"] = "Delivered";
    ShippingStatus["RETURNED"] = "Returned";
    ShippingStatus["AWAITING_PICKUP"] = "Awaiting Pickup";
})(ShippingStatus || (exports.ShippingStatus = ShippingStatus = {}));
